import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  Button,
  Snackbar,
  SnackbarContent,
  IconButton,
} from "@material-ui/core";
import * as React from "react";
import { amber } from "@material-ui/core/colors";
import CloseIcon from "@material-ui/icons/Close";
import ErrorIcon from "@material-ui/icons/Error";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { EventEmitter } from "../events/EventEmitter";
import { convertToBoolean } from "../constants/constants";
export const SNACKBAR_TYPE = {
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
};
const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      padding: 3,
    },
    message: {
      display: "flex",
      alignItems: "center",
    },
    button: {
      margin: theme.spacing(1),
      width: "20%",
      height: 48,
    },
    icon: {
      fontSize: 20,
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary,
    },
    iconVariant: {
      opacity: 0.9,
      marginRight: theme.spacing(1),
    },
    control: {
      padding: theme.spacing(1) * 2,
    },
    success: {
      backgroundColor: "#11b92d",
    },
    error: {
      backgroundColor: theme.palette.error.dark,
    },
    info: {
      backgroundColor: theme.palette.primary.main,
    },
    warning: {
      backgroundColor: amber[700],
    },
  });
interface Props extends WithStyles<typeof styles> {
  type: String;
  open: Boolean;
  message: String;
  onClose?: any;
}
class SnackBarComponent extends React.Component<Props> {
  state = {};

  onLoginClicked = () => {
    EventEmitter.dispatch(EventEmitter.events.SEND_LOGIN_REQUEST, {});
  };
  render() {
    const { open, classes, message, type, onClose } = this.props;
    return (
      <React.Fragment>
        <Snackbar
          open={convertToBoolean(open)}
          autoHideDuration={
            message && message.includes("jwt expired") ? null : 6000
          }
          onClose={() => onClose()}
        >
          <div>
            <SnackbarContent
              className={
                type === SNACKBAR_TYPE.SUCCESS ? classes.success : classes.error
              }
              aria-describedby="client-snackbar"
              message={
                <div>
                  {type === SNACKBAR_TYPE.SUCCESS && (
                    <span id="client-snackbar" className={classes.message}>
                      <CheckCircleIcon className={classes.icon} />
                      <div style={{ width: 10 }} />
                      {message}
                    </span>
                  )}
                  {type === SNACKBAR_TYPE.ERROR && (
                    <span id="client-snackbar" className={classes.message}>
                      <ErrorIcon className={classes.icon} />
                      <div style={{ width: 10 }} />
                      {message && message.includes("jwt expired")
                        ? "Log in session expired"
                        : message}
                    </span>
                  )}
                </div>
              }
              action={[
                <div key="button">
                  {message && message.includes("jwt expired") ? (
                    <Button
                      style={{ color: "white" }}
                      size="medium"
                      onClick={() => this.onLoginClicked()}
                    >
                      LOGIN
                    </Button>
                  ) : (
                    <IconButton
                      key="close"
                      size="small"
                      aria-label="close"
                      color="inherit"
                      onClick={() => onClose()}
                    >
                      <CloseIcon className={classes.icon} />
                    </IconButton>
                  )}
                </div>,
              ]}
            />
          </div>
        </Snackbar>
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(SnackBarComponent);
